<template>
  <div>
    <bar-manut
      single-entity="Pedido de Compra"
      :crud="localCrud"
      :btn-delete="true"
      :more-actions="moreActions"
      @save="handleSave"
      @closeform="handleRetorna"
      @delete="handleDelete"
      @action="handleAction"
    />

    <div class="default-container">
      <!-- MENSAGENS DE VALIDACAO -->
      <validation v-if="errmessages.length" title="Erros de Validação" :messages="errmessages" />

      <!-- ALERTAS DE STATUS -->
      <div v-if="compra.financeiro === 'S'" class="alert alert-warning">
        Alterações bloqueadas. Pedido integrado com financeiro.
      </div>
      <div v-if="compra.status === 'F'" class="alert alert-info">
        Alterações bloqueadas. Pedido finalizado.
      </div>
      <div v-if="compra.status === 'C'" class="alert alert-danger">
        Alterações bloqueadas. Pedido cancelado.
      </div>

      <label-title title="Dados do Pedido" icon="fa-shopping-cart" />

      <div class="row">
        <form-field v-model="compra.npedido" type="text" col="2" :metadata="metadata.compra.npedido" disabled></form-field>
        <form-field v-model="compra.data" type="date" col="2" :metadata="metadata.compra.data" :disabled="isView" name="data" :v-errors="errors" v-validate="metadata.compra.data.validator"></form-field>
        <form-field v-model="compra.dtentrega" type="date" col="2" :metadata="metadata.compra.dtentrega" :disabled="isView" name="dtentrega" :v-errors="errors" v-validate="metadata.compra.dtentrega.validator"></form-field>
        <div class="col-12">
          <input-part ref="part" v-model="compra.codpart" :initial-label="compra.nome_fornecedor" :disabled="isView" name="Fornecedor" :v-errors="errors" v-validate="metadata.compra.codpart.validator"></input-part>
        </div>
      </div>

      <!-- SEÇÃO ITENS -->
      <label-title title="Produtos" icon="fa-archive" class="mt-4" />
      <compra-itens v-model="compra.comprait" :readonly="isView" :metadata="metadata" @change="handleItemsChange"></compra-itens>

      <!-- SEÇÃO TOTAIS EM LINHA -->
      <div class="card bg-light border-0 shadow-sm mt-4">
        <div class="card-body p-2">
          <div class="row align-items-center mx-0">
            <div class="col-md-2 col-6 text-center border-right">
              <small class="text-muted d-block">Subtotal</small>
              <span class="font-bold">R$ {{ subtotal | formatValue(2, true) }}</span>
            </div>

            <div class="col-md-2 col-6 border-right">
              <form-field v-model="compra.vlrfrete" type="value" col="12" :metadata="metadata.compra.vlrfrete" :disabled="isView" @input="calculateTotals" class="mb-0" name="vlrfrete" :v-errors="errors" v-validate="metadata.compra.vlrfrete.validator"></form-field>
            </div>

            <div class="col-md-2 col-6 border-right">
              <form-field v-model="compra.percdesc" type="value" col="12" :metadata="metadata.compra.percdesc" :disabled="isView" @input="updateDescFromPerc" class="mb-0" name="percdesc" :v-errors="errors" v-validate="metadata.compra.percdesc.validator"></form-field>
            </div>

            <div class="col-md-2 col-6 text-center border-right">
              <small class="text-muted d-block"><v-label :metadata-field="metadata.compra.totdesc"></v-label></small>
              <span class="text-red font-bold">R$ {{ compra.totdesc | formatValue(2, true) }}</span>
            </div>

            <div class="col-md-4 col-12 text-center">
              <small class="text-muted d-block"><v-label :metadata-field="metadata.compra.totpedido"></v-label></small>
              <span class="text-xl font-bold text-blue">R$ {{ compra.totpedido | formatValue(2, true) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- SEÇÃO LOGÍSTICA -->
      <label-title title="Logística" icon="fa-truck" class="mt-4" />
      <div class="row">
        <form-field v-model="compra.tipofrete" type="select" col="4" :metadata="metadata.compra.tipofrete" :disabled="isView" name="tipofrete" :v-errors="errors" v-validate="metadata.compra.tipofrete.validator"></form-field>
        <form-field v-model="compra.codtransp" type="select2" col="8" :metadata="metadata.compra.codtransp" name="codtransp"
            :v-errors="errors" v-validate="metadata.compra.codtransp.validator" :disabled="isView"></form-field>

      </div>

      <!-- SEÇÃO FINANCEIRO -->
      <label-title title="Financeiro" icon="fa-money" class="mt-4" />
      <div class="row mb-4">
        <form-field v-model="compra.codnatfin" type="select2" col="6" :metadata="metadata.compra.codnatfin" :select2="{entity: 'natfin/despesas/', minlength: 0}" :disabled="isView" name="codnatfin" :v-errors="errors" v-validate="metadata.compra.codnatfin.validator"></form-field>
      </div>
      <compra-parcelas v-model="compra.comprapar" :total="compra.totpedido" :readonly="isView" :metadata="metadata" :qt-parcelas.sync="compra.parcelas"></compra-parcelas>

      <!-- SEÇÃO OBSERVAÇÕES -->
      <label-title title="Observações" icon="fa-comment" class="mt-4" />
      <div class="row">
        <form-field v-model="compra.obs" type="memo" col="12" :metadata="metadata.compra.obs" :disabled="isView" placeholder="Sairão no pedido impresso..." name="obs" :v-errors="errors" v-validate="metadata.compra.obs.validator"></form-field>
        <form-field v-model="compra.obs_interna" type="memo" col="12" :metadata="metadata.compra.obs_interna" :disabled="isView" placeholder="Uso restrito da empresa..." name="obs_interna" :v-errors="errors" v-validate="metadata.compra.obs_interna.validator"></form-field>
      </div>
    </div>

    <!-- COMPONENTES CUSTOM/OCULTOS -->
    <email-form v-if="showFormEmail" :index="compra.codcompra" tipo="COMPRA" title="Envio de Pedido de Compra" @closeform="closeFormEmail" @send="handleSendEmail"></email-form>

    <div style="display: none">
      <pedido-compra-impressao ref="impressao" v-if="showImpressao" :index="compra.codcompra" @close="handleClosePrint"></pedido-compra-impressao>
    </div>
  </div>
</template>

<script>
import apiCompra from '../api/api-compra'
import { SysVars } from '../main'
import PedidoCompraImpressao from './pedido-compra-impressao.vue'
import compraItens from './compra-itens.vue'
import compraParcelas from './compra-parcelas.vue'
import { apiEmailPDF, apiORDS, apiORDSdelete, apiORDSpost } from '../shared/api-functions'

export default {
  inject: ['$validator'],
  mixins: [apiCompra],
  components: {
    PedidoCompraImpressao,
    compraItens,
    compraParcelas
  },
  props: {
    id: '',
    crud: ''
  },
  data() {
    return {
      MODULO: 'purchase/compra/',
      showFormEmail: false,
      showImpressao: false,
      metadata: this.$store.getters.getEntities.metadata,
      compra: { ...this.$store.getters.getEntities.compra },
      errmessages: [],
      localCrud: ''
    }
  },
  watch: {
  },
  computed: {
    isView() {
      return (this.compra.status !== 'A' || this.compra.financeiro === 'S' || this.localCrud === SysVars.crudView);
    },
    subtotal() {
      return (this.compra.comprait || []).reduce((acc, item) => acc + (item.total || 0), 0)
    },
    moreActions() {
      let actions = []
      if (this.compra.codcompra && this.compra.codcompra !== 'novo') {
        actions.push({ action: 'duplicar', label: 'Duplicar', icon: 'fa-copy' })
        actions.push({ action: 'imprimir', label: 'Imprimir', icon: 'fa-print' })
        actions.push({ action: 'email', label: 'Enviar E-mail', icon: 'fa-envelope' })

        if (this.compra.status === 'A') {
          if (this.compra.financeiro === 'N') {
            actions.push({ action: 'integrar_fin', label: 'Integrar Financeiro', icon: 'fa-money' })
          } else {
            actions.push({ action: 'excluir_fin', label: 'Excluir Financeiro', icon: 'fa-trash' })
          }
          actions.push({ action: 'lancar_entrada', label: 'Lançar Entrada', icon: 'fa-sign-in' })
          actions.push({ action: 'cancelar', label: 'Cancelar Pedido', icon: 'fa-times', danger: true })
        }
      }
      return actions
    }
  },
  async created() {
    const isNovo = this.id === 'novo' || this.crud === SysVars.crudI
    this.localCrud = isNovo ? SysVars.crudI : (this.crud || SysVars.crudU)

    if (!isNovo) {
      await this.loadData(this.id)
    } else {
      this.compra = { ...this.$store.getters.getEntities.compra }
      this.compra.data = this.$getDate()
      this.compra.status = 'A'
      this.compra.financeiro = 'N'
      if (!this.compra.comprait) this.$set(this.compra, 'comprait', [])
      if (!this.compra.comprapar) this.$set(this.compra, 'comprapar', [])
    }
  },
  methods: {
    updateDescFromPerc() {
      this.compra.vlrdesc = Number((this.subtotal * (Number(this.compra.percdesc || 0) / 100)).toFixed(2))
      this.calculateTotals()
    },
    handleItemsChange() {
      if (this.subtotal === 0) {
        this.compra.vlrfrete = 0
        this.compra.vlrdesc = 0
        this.compra.percdesc = 0
      }
      this.calculateTotals()
    },
    calculateTotals() {
      const itens = this.compra.comprait || []
      this.compra.toticm = itens.reduce((acc, it) => acc + (it.vicms || 0), 0)
      this.compra.totimp = itens.reduce((acc, it) => acc + ((it.vipi || 0) + (it.vibs || 0) + (it.vcbs || 0)), 0)

      if (this.compra.percdesc > 0) {
        this.compra.vlrdesc = Number((this.subtotal * (Number(this.compra.percdesc || 0) / 100)).toFixed(2))
      }

      let total = Number((this.subtotal || 0.0)) + Number((this.compra.vlrfrete || 0.0)) + Number((this.compra.totimp || 0.0))
      this.compra.totdesc = Number((this.compra.vlrdesc || 0))
      this.compra.totpedido = total - this.compra.totdesc
    },
    async loadData(id) {
      try {
        const selectedId = id || this.id || this.compra.codcompra
        if (selectedId && selectedId !== 'novo') {
          this.$appLoading(true)
          await this.$store.dispatch('loadCompra', { id: selectedId })
          this.compra = { ...this.$store.getters.getCompra }
          if (!this.compra.comprait) this.$set(this.compra, 'comprait', [])
          if (!this.compra.comprapar) this.$set(this.compra, 'comprapar', [])
          if (this.compra.validation) {
            const validation = JSON.parse(this.compra.validation)
            this.errmessages = validation.errmessages || []
          } else {
            this.errmessages = []
          }
        }
      } catch (error) {
        this.$erpToastError('Erro ao carregar dados do pedido')
      } finally {
        this.$appLoading(false)
      }
    },
    async handleSave() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        this.$erpToastError('Por favor, corrija os campos em destaque')
        return
      }

      let method = this.localCrud === SysVars.crudI ? 'post' : 'put'
      let url = this.MODULO + (method === 'put' ? this.compra.codcompra : '')

      const response = await apiORDSpost(this.$store, url, { compra: this.compra }, method)

      if (response && response.items && response.items.length > 0) {
        const item = response.items[0]
        if (item.validation) {
          const validation = JSON.parse(item.validation)
          this.errmessages = validation.errmessages || []
          this.$erpToastError(validation.message || 'Erro ao salvar pedido')
        } else {
          this.$erpToastSuccess('Pedido salvo com sucesso')
            this.$emit('closeform', item.codcompra)
        }
      } else if (response && response.errmessages) {
        this.errmessages = response.errmessages
        this.$erpToastError('Erro ao salvar pedido')
      }
    },
    handleRetorna() {
      this.$emit('closeform')
    },
    async handleDelete() {
      const url = this.MODULO + this.compra.codcompra
      const res = await apiORDSdelete(this.$store, url)
      if (res && res.error) {
        this.$erpToastError(res.error)
      } else {
        this.$erpToastSuccess('Pedido excluído com sucesso')
        this.handleRetorna()
      }
    },
    handleAction(actionId) {
      const actions = {
        'duplicar': this.onDuplicar,
        'imprimir': this.onImprimir,
        'email': this.onEmail,
        'integrar_fin': this.onIntegrarFin,
        'excluir_fin': this.onExcluirFin,
        'lancar_entrada': this.onLancarEntrada,
        'cancelar': this.onCancelar
      }
      if (actions[actionId]) actions[actionId]()
    },
    onDuplicar() {
      this.apiDuplicaCompra(this.compra.codcompra, (res) => {
        if (res.error) {
          this.$erpToastError(res.error)
        } else {
          this.$erpToastSuccess('Pedido duplicado com sucesso')
          this.$emit('closeform', res.codcompra)
        }
      })
    },
    onImprimir() {
      this.showImpressao = true
      this.$nextTick(function () {
        this.$refs.impressao.print()
      })
    },
    onEmail() {
      this.showFormEmail = true
    },
    closeFormEmail() {
      this.showFormEmail = false
    },
    handleClosePrint() {
      this.showImpressao = false
    },
    async handleSendEmail(data) {
      this.closeFormEmail()
      await apiEmailPDF(this, 'purchaseorder/' + this.compra.codcompra, data)
    },
    onIntegrarFin() {
      this.apiIntegraFinanceiroCompra(this.compra.codcompra, (res) => {
        if (res && res.validation) {
          const validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation
          this.$erpToastError(validation.message || 'Erro na integração')
        } else {
          this.$erpToastSuccess('Financeiro integrado com sucesso')
          this.loadData()
        }
      })
    },
    onExcluirFin() {
      this.apiExcluirFinanceiroCompra(this.compra.codcompra, (res) => {
        if (res && res.validation) {
          const validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation
          this.$erpToastError(validation.message || 'Erro ao excluir financeiro')
        } else {
          this.$erpToastSuccess('Financeiro excluído com sucesso')
          this.loadData()
        }
      })
    },
    onLancarEntrada() {
      this.$router.push({ path: `/nf/${this.compra.codcompra}`, query: { tipo: 'entrada' } })
    },
    onCancelar() {
      this.apiCancelaCompra(this.compra.codcompra, (res) => {
        if (res && res.validation) {
          const validation = typeof res.validation === 'string' ? JSON.parse(res.validation) : res.validation
          this.$erpToastError(validation.message || 'Erro ao cancelar pedido')
        } else {
          this.$erpToastSuccess('Pedido cancelado com sucesso')
          this.loadData()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/compra-form.vue